import { WorkloadReliabilitySummariesResponseItem } from '@cast/types';

import { WorkloadDetailsLinkCell } from 'features/cost-report/components/WorkloadDetailsLinkCell';

import { Typography, Box, Stack, tokens } from '@cast/design-system';

const MAX_ITEMS = 5;

type WorkloadSummaryListRowsProps = {
  items: WorkloadReliabilitySummariesResponseItem[];
  formatMetric: (metric?: number) => string;
  rowTestId?: string;
  /** ranked: spread metrics (narrow cards). compact: metric beside name. */
  variant?: 'ranked' | 'compact';
};

const rowDividerSx = {
  py: 4,
  borderBottom: '1px solid',
  borderColor: tokens.theme.border.structural.neutral,
  '&:last-of-type': {
    borderBottom: 'none',
  },
};

export const WorkloadSummaryListRows = ({
  items,
  formatMetric,
  rowTestId,
  variant = 'ranked',
}: WorkloadSummaryListRowsProps) => {
  const listItems = items.slice(0, MAX_ITEMS);
  const isCompact = variant === 'compact';

  return (
    <Stack gap={8}>
      {listItems.map(
        ({ workloadName, workloadType, namespace, metric }, index) => (
          <Stack
            key={`${workloadName}-${workloadType}-${namespace}`}
            data-testid={rowTestId}
            direction="row"
            alignItems="center"
            flexWrap="nowrap"
            gap={isCompact ? 12 : 8}
            justifyContent={isCompact ? 'flex-start' : 'space-between'}
            sx={rowDividerSx}
          >
            <Stack
              direction="row"
              gap={8}
              minWidth={0}
              flex={isCompact ? '0 1 auto' : 1}
              alignItems="center"
              flexWrap="nowrap"
            >
              <Typography color="textSecondary" flexShrink={0}>
                {index + 1}.
              </Typography>
              <Box
                component="div"
                sx={{
                  minWidth: 0,
                  ...(isCompact && { flexShrink: 1, overflow: 'hidden' }),
                }}
              >
                <WorkloadDetailsLinkCell
                  workload={workloadName}
                  workloadType={workloadType}
                  namespace={namespace}
                />
              </Box>
            </Stack>
            <Typography fontWeight={600} whiteSpace="nowrap" flexShrink={0}>
              {formatMetric(metric)}
            </Typography>
          </Stack>
        )
      )}
    </Stack>
  );
};
